<div class="transferts col-lg-12 col-md-12 col-sm-12 col-xs-12">

	<div class="panel panel-orange" *ngFor="let notification of sortedMetasNotifications">

		<div class="panel-heading">
			<h4>Accès {{ notification.numeroAcces }} fermé</h4>
		</div>

		<div class="panel-body">
			<div class="row form-group">

				<div class="col-md-6 col-sm-6">
					<label class="control-label"> <strong>Ouvrages :</strong>
					</label>

					<ul>
						<li *ngFor="let ouvrage of notification.ouvrages">{{
							ouvrage.code }} : {{ ouvrage.etat }}</li>
					</ul>
				</div>

				<div class="col-md-6 col-sm-6">
					<label class="control-label"> Type Accès : </label>
					{{ formatTypeAcces(notification.typeAcces) }}
				</div>

			</div>
		</div>

		<div class="form-group text-center">

			<button type="button" class="btn btn-default"
				(click)="ok(notification)">OK</button>

		</div>
	</div>


</div>